var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 21.0001V4.0001H11.25C11.1667 4.33343 11.1 4.66676 11.05 5.0001C11 5.33343 10.9833 5.66676 11 6.0001H7V12.0001H14.25L14.65 14.0001H18V12.8501C18.3333 12.8501 18.6667 12.8251 19 12.7751C19.3333 12.7251 19.6667 12.6501 20 12.5501V16.0001H13L12.6 14.0001H7V21.0001H5ZM17.275 8.1001L20.75 4.6501L19.7 3.6001L17.275 5.9751L16.3 5.0001L15.25 6.0751L17.275 8.1001ZM18 0.850098C19.3833 0.850098 20.5625 1.3376 21.5375 2.3126C22.5125 3.2876 23 4.46676 23 5.8501C23 7.23343 22.5125 8.4126 21.5375 9.3876C20.5625 10.3626 19.3833 10.8501 18 10.8501C16.6167 10.8501 15.4375 10.3626 14.4625 9.3876C13.4875 8.4126 13 7.23343 13 5.8501C13 4.46676 13.4875 3.2876 14.4625 2.3126C15.4375 1.3376 16.6167 0.850098 18 0.850098Z",
    fill: "#30B3D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReview);
export default __webpack_public_path__ + "static/media/Review.f72f6cea57fe40bb97c71c51f8c2ca57.svg";
export { ForwardRef as ReactComponent };